import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OverlayModule, BlockScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';

// import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

  res: any = "";
  submitted1 = false;
  mobilno: any;
  contenthide = true ;
  iphonecontenthide=true;
  successcontenthide = true;
  screenW: boolean;
  linebox: boolean;
  countryCode: any;
  countryCode2: any;
  concatNum: any;
  // dialog_1 :any;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private dialog: MatDialog
    ,  public dialog_1: MatDialogRef<TemplateRef<any>>,public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>,public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>, private router: Router,private route: ActivatedRoute
    ){}

    loginPage(){
      //console.log("redirect to login page");
      
      this.router.navigateByUrl("/login")
    }
    openess(){
      window.open(environment.ess);


    }
    opendownload(){
      this.router.navigateByUrl("/Download")

    }
    opencitrix(){
     window.open(environment.citrix);
    }

    refreshpage(){
      location.reload();
    }
  showModal(content) {
    this.contenthide = false;
     this.dialog_1 =  this.dialog.open(content,{
      panelClass: 'custom-dialog-container',
      autoFocus :false,
      restoreFocus : true,
      role :'dialog',
      disableClose : true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';
      
    })


  }
  modal1 = new FormGroup({
    jioId: new FormControl()
  });

  modal2 = new FormGroup({
    jioId: new FormControl()
  });



  dismissmodal() {
    this.dialog.closeAll()
    this.modal1.reset();
    this.modal2.reset();

  }
  ngOnInit() {

    this.route.fragment.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })
    
    // console.log(window.screen.width);
    if(window.screen.width >= 1100){  //class=aside visibility for desktop
      this.screenW = true;
      this.linebox = false;
    }
    else{
      this.screenW = false;
      this.linebox = true;
    }
    
    this.modal1 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^[0-9]*$'),Validators.minLength(4), Validators.maxLength(15)]]
    })

    this.modal2 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^[0-9]*$'),Validators.minLength(4), Validators.maxLength(15)]]
    })

    // document.getElementById("errorM1").style.display = "none";
    // document.getElementById("errorM2").style.display = "none";


  }

  get f1() { return this.modal1.controls; }
  get f2() { return this.modal2.controls; }

  openapk() {

    this.dismissmodal();
    // window.open('./assets/apk/JioID-1.0.4.apk');
    window.open(environment.androidlink);


  }

  openipapk(){
this.dismissmodal();
window.open(environment.iOSlink);
  }

  first(){
    if(this.modal1.invalid){
      document.getElementById("errorM1").style.display = "block";
    }
    else{
      document.getElementById("errorM1").style.display = "none";
    }
  }
  onCountryChange1(event){
    console.log("here is number " +event.dialCode);
    // localStorage.setItem("tempEvent",event.dialCode)
    this.countryCode = event.dialCode;
  }

  sendphonelink1(successcontent,successlinksent,failurelinksent) {   
    this.submitted1 = true;
    if (this.modal1.invalid) { 
  
      document.getElementById("errorM1").style.display="block";  
    }
  else{
    document.getElementById("errorM1").style.display="none";
    
    // let data = {
    //   "phoneno": this.modal1.value.jioId,
    //   "flag": "0"
    // }
  //console.log(data);

  if(this.countryCode == 91){
    this.concatNum = this.modal1.value.jioId;
  }
  else if(this.countryCode){
    this.concatNum = "+"+this.countryCode+"-"+this.modal1.value.jioId;
  }
  else{
    this.concatNum = this.modal1.value.jioId;
  }

  console.log("this.concatNum = "+this.concatNum);
  
    this.http.post(environment.sendSms.concat(this.modal1.value.jioId+"&url=1"), {}).subscribe(
      data => {
        //console.log(data);
  
        this.res = data;
        // if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.contenthide = true;

  
          this.dialog_3 =  this.dialog.open(successlinksent,{
            panelClass: 'customlink-dialog-container',
           
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
          
            
          })
        // }
        // else {
        //   // this.dialog.closeAll()
        //   this.contenthide = true;
  
        //   this.dialog_4 =  this.dialog.open(failurelinksent,{
        //     panelClass: 'customlink-dialog-container',
            
        //     disableClose:true,
          
        //     restoreFocus : false,
        //     role :'dialog',
        //     autoFocus:false,
            
        //   })
  
        // }
  
        ;
      },
      err =>{
        this.contenthide = true;
  
        this.dialog_4 =  this.dialog.open(failurelinksent,{
          panelClass: 'customlink-dialog-container',
          
          disableClose:true,
        
          restoreFocus : false,
          role :'dialog',
          autoFocus:false,
          
        })

      }
      )
    }
  };  

  second(){
    if(this.modal2.invalid){
      document.getElementById("errorM2").style.display = "block";
    }
    else{
      document.getElementById("errorM2").style.display = "none";
    }
  }

  onCountryChange2(event){
    console.log("here is number " +event.dialCode);
    // localStorage.setItem("tempEvent",event.dialCode)
    this.countryCode2 = event.dialCode;
  }

  sendphonelink2(successcontent,successlinksent2,failurelinksent) {
    this.submitted1 = true;
    if (this.modal2.invalid) {
  
  
      document.getElementById("errorM2").style.display="block";
  
  
  
    }
  else{
  
  document.getElementById("errorM2").style.display="none";

    // let data = {
    //   "phoneno": this.modal1.value.jioId,
    //   "flag": "1"
    // }
  //console.log(data);

  if(this.countryCode2 == 91){
    this.concatNum = this.modal2.value.jioId;
  }
  else if(this.countryCode2){
    this.concatNum = "+"+this.countryCode2+"-"+this.modal2.value.jioId;
  }
  else{
    this.concatNum = this.modal2.value.jioId;
  }

  console.log("this.concatNum = "+this.concatNum);
  

    this.http.post(environment.sendSms.concat(this.modal1.value.jioId+"&url=2"), {}).subscribe(
      data => {
        //console.log(data);
        this.res = data;
        // if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.iphonecontenthide = true;
  
          this.dialog_3 =  this.dialog.open(successlinksent2,{
            panelClass: 'customlink-dialog-container',
            
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
            
          })
  
  
        // }
        // else {
        //   // this.dialog.closeAll()
        //   this.iphonecontenthide = true;
  
        //   this.dialog_4 =  this.dialog.open(failurelinksent,{
        //     panelClass: 'custom-dialog-container',
            
        //     disableClose:true,
          
        //     restoreFocus : false,
        //     role :'dialog',
        //     autoFocus:false,
            
        //   })
  
        // }
  
        ;
      },
      err =>{
        this.iphonecontenthide = true;
        this.dialog_4 =  this.dialog.open(failurelinksent,{
          panelClass: 'customlink-dialog-container',
          
          disableClose:true,
        
          restoreFocus : false,
          role :'dialog',
          autoFocus:false,
          
        })

      })
    }
    }
  showModal1(successcontent){
    
    this.successcontenthide = false;
    this.dialog_2 =  this.dialog.open(successcontent,{
       panelClass: 'success-dialog-container',
       restoreFocus : true,
       role :'dialog',
       autoFocus:false,
       disableClose : true,
       // height:'200px'
       // padding-left: '17%';
       // padding-right: '17%';
       
     })

  }
  sendandroidphonelink(content){
    this.successcontenthide = true;
    this.contenthide = false;
    this.dialog_1 =  this.dialog.open(content,{
     panelClass: 'contentCustom-dialog-container',
     autoFocus :false,
     restoreFocus : true,
     role :'dialog',
     disableClose : true,

     // height:'200px'
     // padding-left: '17%';
     // padding-right: '17%';
     
   })


  }
  sendiphonelink(iphonecontent){
    this.successcontenthide = true;

    this.iphonecontenthide = false;
    this.dialog_1 =  this.dialog.open(iphonecontent,{
     panelClass: 'contentCustom-dialog-container',
     autoFocus :false,
     restoreFocus : true,
     role :'dialog',
     disableClose : true,

     // height:'200px'
     // padding-left: '17%';
     // padding-right: '17%';
     
   })


  }

  copyLink(){
     /* Copy the text inside the text field */
  navigator.clipboard.writeText("https://play.google.com/store/apps/details?id=com.jio.secureid");

  /* Alert the copied text */
  // alert("Copied the link: https://bit.ly");
  }

  copyLinkIOS(){
      /* Copy the text inside the text field */
  navigator.clipboard.writeText("https://apps.apple.com/us/app/jio-secureid/id1610736799");
  }

  downloadPage() {
    window.location.reload();
  }

}

